import React from "react"
import liff from '@line/liff';
import AppConfig from './AppConfig.json'
import AATagging from "./AATagging"
// import moment from "moment";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as Helper from "./Helper";

export class LinkedScreen extends React.Component {
    async componentDidMount() {
        // let { currentUserProfile, currentLoyaltyMemberDetail } = this.props.app
        let { currentLoyaltyMemberDetail } = this.props.app
        try {
            // let isT1X = false

            // try {
            //     if (currentUserProfile.segments) {
            //         for (let s in currentUserProfile.segments) {
            //             if (currentUserProfile.segments[s].segmentLevel === "T1X") {

            //                 if (currentUserProfile.segments[s].endDate) {
            //                     let isExpire = moment(currentUserProfile.segments[s].endDate, 'DDMMYYYY').isBefore(moment())
            //                     // console.log(moment(currentUserProfile.segments[s].endDate, 'DDMMYYYY').format(), moment(currentUserProfile.segments[s].endDate, 'DDMMYYYY').isAfter(moment()))
            //                     isT1X = !isExpire
            //                 }
            //                 break
            //             }
            //         }
            //     }
            // }
            // catch (e) {
            //     console.error(e)
            // }

            if (liff.getOS() === 'web' && Helper.isMissionStickerCampaign()) {
                // let result = await axios.post(`${AppConfig.endpoint}/member/welcome`, {}, {
                //     headers: {
                //         "x-access-token": this.props.app.accessToken,
                //         "x-api-key": AppConfig.api_key
                //     }
                // })
            }
            else if (liff.isLoggedIn()) {
                liff.sendMessages([
                    {
                        type: "text",
                        text: "เชื่อมต่อบัญชี The 1"
                    }
                ])
            }

            AATagging.trackSigninComplete(Helper.getCardNo(currentLoyaltyMemberDetail), Helper.isT1X(currentLoyaltyMemberDetail))
        }
        catch (err) {
            console.log(err)
        }
    }

    render() {
        let { currentLoyaltyMemberDetail } = this.props.app
        let missionStickerMode = Helper.isMissionStickerCampaign()

        if (missionStickerMode) {
            return <div className="error-page has-text-centered" style={{ padding: 0, background: "#dae2ff", minHeight: "100vh" }}>
                <div style={{ minHeight: 400 }}>
                    <img alt="" src="/mission_stickers/sticker_landing02_2.jpg" style={{ width: '100%' }} />

                    <div className="screen-footer" style={{ paddingBottom: 40 }}>
                        <button
                            type="button"
                            className="button is-fullwidth is-save"
                            style={{ marginTop: 10 }}
                            onClick={() => {
                                AATagging.trackSigninCompleteBackToLine(Helper.getCardNo(currentLoyaltyMemberDetail), Helper.isT1X(currentLoyaltyMemberDetail));
                                setTimeout(() => {
                                    window.location.href = "https://line.me/S/sticker/26220";
                                }, 1500);
                            }}
                        >
                            โหลดสติกเกอร์เลย!
                        </button>

                        <div style={{ color: "#555", fontSize: "0.8em", paddingTop: 10 }}>
                            ฉันได้ยอมรับนโยบายความเป็นส่วนตัว และ ข้อตกลงและเงื่อนไข เรียบร้อยแล้ว<br />
                        </div>
                        <a href="https://www.the1.co.th/privacy" target="_blank" style={{ color: "#" }} rel="noreferrer">นโยบายความเป็นส่วนตัว</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <a href="https://www.the1.co.th/terms-and-conditions" target="_blank" rel="noreferrer">ข้อตกลงและเงื่อนไข</a>
                        {/* <a onClick={() => {
                    AATagging.trackSigninCompleteBackToLine(Helper.getCardNo(currentLoyaltyMemberDetail), Helper.isT1X(currentLoyaltyMemberDetail))

                    setTimeout(() => {
                        liff.closeWindow()
                    }, 1500)
                }}
                    className="button is-fullwidth is-outlined" style={{ marginTop: 10 }}  >OK</a> */}
                        {/* <a className="button is-fullwidth is-outlined" style={{ marginTop: 10 }} onClick={() => liff.closeWindow()} >Cancel</a> */}
                    </div>
                </div>
            </div>
        }
        else {
            return <div className="error-page has-text-centered" style={{ paddingTop: 40 }}>
                <img alt="Congratulations" src="/congratulations.png" style={{ width: 240 }} />
                <div className="subtitle" style={{ fontSize: 24 }}>
                    Completed!
                </div>
                <p>
                    Account was successfully linked with The 1
                </p>

                <div className="screen-footer">
                    <button
                        type="button"
                        className="button is-fullwidth is-save"
                        style={{ marginTop: 10 }}
                        onClick={() => {
                            AATagging.trackSigninCompletGetTheApp(Helper.getCardNo(currentLoyaltyMemberDetail), Helper.isT1X(currentLoyaltyMemberDetail));
                            setTimeout(() => {
                                window.location.href = AppConfig.url_app_info_update;
                            }, 1500);
                        }}
                    >
                        Get The 1 app&nbsp;&nbsp;
                        <img src="/the1-logo.png" style={{ height: 36 }} alt="The 1 Logo" />
                    </button>
                    <button
                        type="button"
                        className="button is-fullwidth is-outlined"
                        style={{ marginTop: 10 }}
                        onClick={() => {
                            AATagging.trackSigninCompleteBackToLine(Helper.getCardNo(currentLoyaltyMemberDetail), Helper.isT1X(currentLoyaltyMemberDetail));
                            setTimeout(() => {
                                liff.closeWindow();
                            }, 1500);
                        }}
                    >
                        Back To LINE
                    </button>
                    {/* <a className="button is-fullwidth is-outlined" style={{ marginTop: 10 }} onClick={() => liff.closeWindow()} >Cancel</a> */}
                </div>
            </div>
        }
    }
}

export default withRouter(connect((state) => state, null)(LinkedScreen))